import { render, staticRenderFns } from "./game-doublechancelotto.vue?vue&type=template&id=6bf71071"
import script from "./game-doublechancelotto.vue?vue&type=script&lang=js"
export * from "./game-doublechancelotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-doublechancelotto.vue
// module id = vVAD
// module chunks = 0